export const fakeDocuments = Array.from({ length: 4 }, (_, index) => ({
  file: {
    original_filename: `Document-${index}`,
    bytes: 100000,
    secure_url: "https://pay-first.money",
  },
}));
